import { DefaultReminderOffsets } from 'owa-calendar-reminder-options';
import { logUsage } from 'owa-analytics';

export default function logInboxReminderOffsetOption(reminderOffset: number) {
    let datapointSuffix;
    let customData = null;
    switch (reminderOffset) {
        case DefaultReminderOffsets.AT_TIME_OF_EVENT:
            datapointSuffix = 'AtTimeOfEvent';
            break;
        case DefaultReminderOffsets.MINUTES_BEFORE_5:
            datapointSuffix = '5MinutesBefore';
            break;
        case DefaultReminderOffsets.MINUTES_BEFORE_15:
            datapointSuffix = '15MinutesBefore';
            break;
        case DefaultReminderOffsets.MINUTES_BEFORE_30:
            datapointSuffix = 'InboxReminder30MinutesBefore';
            break;
        case DefaultReminderOffsets.HOURS_BEFORE_1:
            datapointSuffix = '1HourBefore';
            break;
        case DefaultReminderOffsets.HOURS_BEFORE_2:
            datapointSuffix = '2HoursBefore';
            break;
        case DefaultReminderOffsets.HOURS_BEFORE_12:
            datapointSuffix = '12HoursBefore';
            break;
        case DefaultReminderOffsets.DAYS_BEFORE_1:
            datapointSuffix = '1DayBefore';
            break;
        case DefaultReminderOffsets.DAYS_BEFORE_7:
            datapointSuffix = '1WeekBefore';
            break;
        case DefaultReminderOffsets.DAY_OF_EVENT_MIN:
            datapointSuffix = 'DayOfEvent';
            break;
        case DefaultReminderOffsets.DAY_BEFORE_MORNING_MIN:
            datapointSuffix = 'DayBeforeMorning';
            break;
        case DefaultReminderOffsets.DAY_BEFORE_MIN:
            datapointSuffix = 'DayBeforeEvent';
            break;
        case DefaultReminderOffsets.WEEK_BEFORE_MIN:
            datapointSuffix = 'WeekBeforeMin';
            break;
        default:
            // Custom reminder offset
            datapointSuffix = 'Custom';
            customData = {
                isFuture: reminderOffset > 0,
            };
            break;
    }

    logUsage('ReminderOffset' + datapointSuffix, customData);
}
